import { ReactNode } from 'react'
import { IndicationWrapper } from './styles'

interface IProps {
  children: ReactNode,
  hasError?: boolean
}

const Indication = (props: IProps) =>
  <IndicationWrapper hasError={props.hasError || false}>
    {props.children}
  </IndicationWrapper>

export default Indication
